import styled from 'styled-components';

import { ANIM, COLORS, PLAYABLE_PREVIEW, REDUCED_MOTION } from '@/nova/theme/tokens';

export { PosterImg } from '../AdLibraryShell/AdLibraryShell.styles';

/** The card poster's content: the background plate (as before), with the game drawn over the whole frame once it is
 *  in view and loaded. Under the shell's status pill and generating overlay (both stacked above it). */
export const GamePosterBox = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

/** The game at rest, over the plate: hidden until its document has loaded (the plate stays on screen meanwhile),
 *  then faded in. Never interactive: a click goes to the card, which opens the editor. */
export const GameLayer = styled.div<{ $shown: boolean }>`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  pointer-events: none;
  background: ${COLORS.surfaceInset};
  opacity: ${(p) => (p.$shown ? 1 : 0)};
  transition: opacity ${PLAYABLE_PREVIEW.SWAP_MS}ms ${ANIM.EASE};

  ${REDUCED_MOTION} {
    transition: none;
  }

  /* The preview box rounds its corners for a framed preview; the card's poster is full bleed. */
  & > * {
    border-radius: 0;
  }
`;
